import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Grid } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { useNodeTemplate } from '../../../hooks';
import { RFConfigContext } from '../../../contexts';
import { CAT_CRACKING_CONFIG } from './RFCatCrackingNode.config';
/**
 * Component renders "catCracking" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFCatCrackingNodeFC = ({ id, data, type, isConnectable = true, selected }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: CAT_CRACKING_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { "data-templateid": data.templateCode, templateRows: "auto auto", children: [_jsx(RFNodeIcon, { id: id, rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: _jsx(RFSvg, { name: CAT_CRACKING_CONFIG.icon, width: 172, height: 172 }) }), _jsx(Box, { p: "4px 0 0 100px", children: _jsx(Box, { maxW: "80px", fontSize: "12px", lineHeight: "14px", fontWeight: 700, className: "cut-text", children: data.title }) })] }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFCatCrackingNode = RFCatCrackingNodeFC;
//# sourceMappingURL=RFCatCrackingNode.js.map